export const GET_STATIC_PAGE = 'static/GET_STATIC_PAGE';
export const POST_FEEDBACK = 'static/POST_FEEDBACK';
export const CLEAR_STATIC_PAGE = 'static/CLEAR_STATIC_PAGE';



// WEBPACK FOOTER //
// ./src/constants/staticPage.js